import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "That one time a simple for-loop increased conversions by 19%",
  "description": "",
  "published": "2017-10-20T00:00:00.000Z",
  "redirect_from": ["/blog/simple-for-loop-increased-conversions/swizec/7875"],
  "categories": "Startups, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Once upon a time, I made a brilliant decision: We're going to make a new background worker for every analytics event on our platform.`}</p>
    <p>{`The goal was simple: have real-time analytics, don't be bound to a single provider, keep local copies of all events in case something goes wrong.`}</p>
    <p>{`I designed a system that does that. Clients (web and mobile) send events to our server, our server stores them in the database and creates a new worker on the queue. That worker runs, sends the event to Mixpanel, and marks it as sent.`}</p>
    <p>{`With this design, we can easily switch to a different provider. Just change the call on our backend, clients keep the same API. Wonderful.`}</p>
    <p>{`If anything goes wrong when talking to Mixpanel, or if we need to run a complex query involving events and the rest of our data, we can. All events are stored. Wonderful.`}</p>
    <p>{`Job well done.`}</p>
    <p><img parentName="p" {...{
        "src": "/3ff9bad46ee256d6f82fc2ded0443315/media-Mp4hQy51LjY6A-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`Until one day `}<a parentName="p" {...{
        "href": "https://www.yup.com"
      }}>{`Yup`}</a>{` got a lot of traffic.`}</p>
    <p>{`No, the analytics didn't stop working. Our database didn't get flooded. Oh no. Don't you worry about our database. Postgres can handle hundreds of millions of rows. Postgres is a champ.`}</p>
    <p>{`No, no. What happened was that our "We send code to your phone to log in" system stopped sending out codes. 2 minutes, 3 minutes, sometimes an hour late. Often ten codes at a time would arrive to the same person because they retried so often. Codes were out of sequence, too.`}</p>
    <p>{`Wait what?`}</p>
    <p>{`A-ha! Let me explain!`}</p>
    <p>{`You see, we use `}<a parentName="p" {...{
        "href": "https://github.com/mperham/sidekiq"
      }}>{`Sidekiq`}</a>{` to queue our background jobs. It assigns all your tasks to a `}<inlineCode parentName="p">{`default`}</inlineCode>{` queue unless you specify.`}</p>
    <p>{`Somewhere along the line, we got lazy and we stopped specifying. Everything went to the same queue and it worked great. Until we had traffic.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/10/backed-up-queue.png",
        "alt": null
      }}></img></p>
    <p>{`Once we had traffic, our analytics workers filled up the queue. Users created tens of them before they even got to the login screen. Others were creating hundreds past the login screen.`}</p>
    <p>{`At one point, we estimate we had almost 20,000 jobs stuck in the queue. Most of them were analytics. Some of them were business critical. Many of them were waiting to let people login and try our service.`}</p>
    <p>{`😅`}</p>
    <p>{`How do you fix this?`}</p>
    <p>{`With a `}<inlineCode parentName="p">{`for`}</inlineCode>{` loop.`}</p>
    <p>{`Let me explain.`}</p>
    <p>{`Say you're sending each event in its own worker. The job itself is really fast. It takes less than 1 second to execute. But scheduling that job, keeping it around, making a worker to run it, executing the Ruby on Rails machinery… all that takes time. A lot of time.`}</p>
    <p>{`But instead of being eager and opportunistic, you can send events in batches. Say a worker wakes up every 5 minutes and sends all events from the past 5 minutes that haven't been sent yet.`}</p>
    <p>{`Now you have a worker that takes longer to run. Several seconds, even a few minutes.`}</p>
    <p><strong parentName="p">{`But you run only 30 jobs per hour instead of 10,000.`}</strong></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/10/batched-queue.png",
        "alt": null
      }}></img></p>
    <p>{`The downside? Instead of real-time analytics, you have to wait 5 minutes to see what's up.`}</p>
    <p>{`How often do you check those charts anyway? Once a day? Every hour? Pretty sure you're not checking every two seconds.`}</p>
    <p>{`Code send times dropped from an average of 3 to 4 minutes to an average of about 10 seconds. Sometimes 20.`}</p>
    <p>{`Our conversion rate from downloading `}<a parentName="p" {...{
        "href": "https://www.yup.com"
      }}>{`Yup`}</a>{` to having a trial increased by 19%. All from a 5-line `}<inlineCode parentName="p">{`for`}</inlineCode>{` loop. Boom.`}</p>
    <p><img parentName="p" {...{
        "src": "/51811cc10cf143b1d493614a7c8807e6/media-OK27wINdQS5YQ-giphy.gif",
        "alt": null
      }}></img></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      